import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: ({ headingAlignment }) => ({
    backgroundColor: theme.palette.blue.light25,
    padding: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: headingAlignment === 'Left' ? 'flex-start' : 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3),
    },
  }),
  overText: {
    fontSize: '1rem',
    color: theme.palette.grey.dark,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  headline: {
    color: theme.palette.secondary.light,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  subtitle: ({ headingAlignment }) => ({
    marginBottom: theme.spacing(5),
    textAlign: headingAlignment === 'Left' ? 'left' : 'center',
    width: '75%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }),
  categoryTagsRow: {
    display: 'flex',
    gap: '0.625rem',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      'overflow-x': 'scroll',
    },
  },
  categoryTags: {
    ...theme.typography.formTags,
    minWidth: '135px',
    height: '45px',
    textAlign: 'center',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    transition: '250ms',
    backgroundColor: 'white',
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.formLabel,
      flexShrink: '0',
      fontSize: '12px',
      width: '110px',
    },
    '&:hover, &:active': {
      textDecoration: 'none',
      backgroundColor: theme.palette.blue.main,
      color: theme.palette.offwhite.main,
    },
  },
  active: {
    backgroundColor: theme.palette.blue.main,
    color: theme.palette.offwhite.main,
    '&:focus-visible': {
      outlineColor: 'black',
    },
  },
  divider: {
    width: '100%',
    opacity: '0.5',
    height: '1px',
    backgroundColor: theme.palette.grey.light,
    marginBottom: theme.spacing(4),
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(4),
    },
  },
  noResultsTitle: {
    color: theme.palette.secondary.light,
  },
  noResultsContainer: {
    height: '300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      height: '250px',
    },
  },
  noResultsBody: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  input: {
    boxShadow: theme.palette.shadow.cardBoxShadow,
    backgroundColor: theme.palette.common.white,
    borderRadius: '8px',
    padding: '1rem',
    marginBottom: theme.spacing(3),
    width: '100%',
    '&>div': {
      '&::before': {
        borderBottom: 'none !important',
      },
      '&::after': {
        borderBottom: 'none !important',
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '90%',
    },
  },
  locationInput: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  selectPlaceholder: {
    color: theme.palette.grey.main,
  },
  selectArrow: {
    color: theme.palette.blue.main,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  menuItem: {
    padding: '1rem',
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      fontWeight: 'bold',
      color: theme.palette.common.white,
    },
  },
  selectPaper: {
    paddingLeft: 0,
    borderRadius: '8px',
    '& ul': {
      padding: '0',
    },
    '& li': {
      textTransform: 'capitalize',
    },
  },
}))

export default useStyles
